const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @components
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');

class BrokerMIFIDUSPersonLinkButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.history.push(this.props.to);
    }

    render() {
        return <BrokerMiFIDUSPersonButton {...this.props} onClick={this.handleClick}/>;
    }
}

BrokerMIFIDUSPersonLinkButton.propTypes = {
    history: PropTypes.object.isRequired,
    to: PropTypes.string.isRequired,
    isinId: PropTypes.string.isRequired,
    marketId: PropTypes.string,
    onCancel: PropTypes.func,
    children: PropTypes.any
};

module.exports = withRouter(BrokerMIFIDUSPersonLinkButton);
